import styled from '@emotion/styled';
import BlogCategoryBadge from '../BlogCategoryBadge';
import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import { PostsCategoryResponse } from 'models/swagger-spring/data-contracts';

const BlogContentCardTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
`;

const BlogContentCardTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

type Props = {
  title: string;
  category: PostsCategoryResponse;
  children?: React.ReactNode;
};

export default function BlogContentCardText({ title, category, children }: Props) {
  return (
    <>
      <BlogContentCardTextWrapper>
        <BlogContentCardTitleWrapper>
          <BlogCategoryBadge category={category} />
          <Typography variant={TypoVariant.SH2}>{title}</Typography>
        </BlogContentCardTitleWrapper>
        {children}
      </BlogContentCardTextWrapper>
    </>
  );
}
